import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-general',
  templateUrl: './modal-general.component.html',
  styleUrls: ['./modal-general.component.scss']
})
export class ModalGeneralComponent {
  @ViewChild('modal') template: TemplateRef<any>;
  private modalRef: NgbModalRef;
  @Input() titulo: string = '';
  @Input() mensagem: string = '';
  @Input() botao: string = '';
  @Output() cliqueBotao = new EventEmitter();
  @Output() fecharModal = new EventEmitter();
  /**
   * a variável bgColor corresponde a cor do fundo do botão, por padrão ela assume a variável --light-00, caso o dev queira mudar a cor, deve passar a nova cor
   * como prop ex: <app-modal-general [bgColor]="novaBackgroundColor"></app-modal-general>
   */
  @Input() bgColor: string = 'var(--light-00)';

  /**
   * a variável color corresponde a cor do texto do botão, por padrão ela assume a variável --company-01, caso o dev queira mudar a cor, deve passar a nova cor
   * como prop ex: <app-modal-general [color]="novaCor"></app-modal-general>
   */
  @Input() color: string = 'var(--company-01)';

  /**
   * a variável color corresponde a cor da borda do botão, por padrão ela assume a variável --company-01, caso o dev queira mudar a cor, deve passar a nova cor
   * como prop ex: <app-modal-general [border]="novaBorderColor"></app-modal-general>
   */
  @Input() border: string = 'var(--company-01)';

  /** passar o parâmetro como "false" caso não queira que o botão ou a mensagem (respectivamente) apareçam no modal <app-modal-general [showOrHideButton]="false">*/
  @Input() showOrHideButton: boolean = true;
  @Input() showOrHideMessage: boolean = true;
  @Input() reloadWindowOnClose: boolean = false;

  constructor(private modalService: NgbModal) {}

  openModal(options?: NgbModalOptions) {
    this.modalRef = this.modalService.open(this.template, {
      centered: true,
      size: 'lg',
      ...options
    });
  }

  pressButton() {
    this.cliqueBotao.emit();
  }

  closeModal(): void {
    this.fecharModal.emit();
    this.modalRef.close();
    if (this.reloadWindowOnClose) {
      window.location.reload();
    }
  }
  closeModalWithoutReload(): void {
    this.modalService.dismissAll();
  }
}
